const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const authHeaders = async (getToken) => {
  const token = await getToken();

  if (!token) return {};

  return {
    Authorization: `Bearer ${token}`,
  };
};

const parseJson = async (res) => {
  try {
    return await res.json();
  } catch (_) {
    return null;
  }
};

export const fetchEntitlementStatus = async (getToken) => {
  const res = await fetch(`${API_BASE_URL}/api/entitlement/me`, {
    headers: await authHeaders(getToken),
  });
  const data = await parseJson(res);

  return {
    status: res.status,
    data,
  };
};
